import { render, staticRenderFns } from "./PurchasesLayout.vue?vue&type=template&id=6a17c8b6&scoped=true&"
import script from "./PurchasesLayout.vue?vue&type=script&lang=js&"
export * from "./PurchasesLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a17c8b6",
  null
  
)

export default component.exports